module.exports = __webpack_public_path__ + "img/main-active.b5560fa6.png";